import {
  ApiSlugs,
  ListPagination,
  UserSessionFilterKey,
  UserSessionId,
  UserSessionSummaryAdminDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserSessionsAdminConnector extends ApiConnector<
  UserSessionSummaryAdminDto,
  UserSessionSummaryAdminDto,
  UserSessionId
> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.SESSIONS}`);
  }

  list(pagination?: ListPagination<UserSessionFilterKey>): Observable<UserSessionSummaryAdminDto[]> {
    return this.apiCaller.getRequest<UserSessionSummaryAdminDto[]>(
      this.apiPrefix,
      `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
    );
  }

  count(pagination?: ListPagination<UserSessionFilterKey>): Observable<number> {
    return this.apiCaller.getRequest<number>(
      this.apiPrefix,
      `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
    );
  }
}
